import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var AdminAddDesignationRes;
export const AdminAddDesignationTodo = createAsyncThunk('adminAdminAddDesignation', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/designation_admin',
            data: {
                "name": data?.designation,
                "company_id": localStorage.getItem('companyId'),
                "status": data?.status,
                "added_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AdminAddDesignationRes = res.data

    } catch (error) {
        return AdminAddDesignationRes = error.response.data
    }
})